// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__Kgv9F {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__oXqrA {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
}

.style_buttons__xc-Pw {
  display: flex;
  gap: 10px;
}

.style_account__Rmd8i {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.style_account_info__YX6YD {
  display: flex;
  align-items: center;
  gap: 10px;
}

.style_inputs_area__q6R0O {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
  gap: 30px;
}

.style_text_field__HD6Cl {
  width: 410px;
}

.style_checkboxes_area__rnluF {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: nowrap;
  gap: 20px;

  @media (max-width: 1024px) {
    flex-direction: column;
    flex-wrap: wrap;
    gap: 40px;
  }
}

.style_checkboxes__pvL3h {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.style_checkboxes_area__rnluF > * {
  flex: 1 1;
  min-width: 0;
  max-width: calc(25% - 15px);

  @media (max-width: 1024px) {
    flex: none;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserProfile/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;;EAET;IACE,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,2BAA2B;;EAE3B;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.account {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.account_info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.inputs_area {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 40px;\n  gap: 30px;\n}\n\n.text_field {\n  width: 410px;\n}\n\n.checkboxes_area {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  flex-wrap: nowrap;\n  gap: 20px;\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 40px;\n  }\n}\n\n.checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.checkboxes_area > * {\n  flex: 1;\n  min-width: 0;\n  max-width: calc(25% - 15px);\n\n  @media (max-width: 1024px) {\n    flex: none;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__Kgv9F`,
	"header": `style_header__oXqrA`,
	"buttons": `style_buttons__xc-Pw`,
	"account": `style_account__Rmd8i`,
	"account_info": `style_account_info__YX6YD`,
	"inputs_area": `style_inputs_area__q6R0O`,
	"text_field": `style_text_field__HD6Cl`,
	"checkboxes_area": `style_checkboxes_area__rnluF`,
	"checkboxes": `style_checkboxes__pvL3h`
};
export default ___CSS_LOADER_EXPORT___;
